/* Google Analytics 4 helpers. The gtag snippet is in the page shell
   (scripts/templates/index.html) with automatic page views disabled; the
   router reports them instead. The property is the market's own. */

import { REGION } from '../config/region';

export const GA_MEASUREMENT_ID = REGION.site.gaMeasurementId;

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

export function trackEvent(name: string, params: Record<string, string | number> = {}) {
  window.gtag?.('event', name, params);
}

export function trackPageView(path: string) {
  // Wait a frame so react-helmet has applied the new route's <title>
  window.requestAnimationFrame(() =>
    window.setTimeout(() =>
      trackEvent('page_view', {
        page_path: path,
        page_location: window.location.href,
        page_title: document.title,
      })
    )
  );
}
